const regexErrorMap = [
  { regex: /^.{5,}$/, error: "اسم الموظف يجب ان يكون 5 احرف على الاقل" },
  { regex: /^.{8,}$/, error: "كلمة السر يجب ان تكون 8 احرف على الاقل" },
];

export const getRegexErrorMessage = (value, regex) => {
  const match = regexErrorMap.find(
    (entry) => entry.regex.toString() === regex.toString()
  );

  if (match && !match.regex.test(value)) {
    return match.error;
  }

  return null;
};
